export default __webpack_public_path__ + "static/traefikee-dashboard-e4857474906e6af4f805e71ad8f06f9c.mp4";